import { PushApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { KEY } from './keys';
import { getQueryKeys } from 'queries/query-key';

function usePost() {
  const queryClient = useQueryClient();
  return useAuthMutation(PushApi.post, {
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).lists(),
      });
    },
  });
}

export default usePost;
